export class PlacardDetailsSession {

    public togglePlacard: boolean = false;
    public placardTypekey: string = '';
    public placardSizeKey: string = '';
   
}